export const alertRedBg = '#fee9e7';
export const auroMetalSaurus = '#627D78';
export const azureLight = '#60F1C8';
export const background = '#F4F4F6';
export const backgroundGrey = '#65748f';
export const black = '#000000';
export const blue = '#3A16FF';
export const blueCharcoal = '#000103';
export const blueLightGrey = '#C2CBD1';
export const breakerBay = '#5EAB9B';
export const cherryRed = '#EC092F';
export const midRed = '#d21931';
export const darkerGrey = '#828282';
export const darkerOrange = '#FF6C40';
export const darkGrey = '#B8B8B8';
export const darkMildGray = '#BDBDBD';
export const darkPink = '#F33C4D';
export const deepAmethyst = '#A58E9C';
export const dustyGray = '#999999';
export const fucsia = '#BD10E0';
export const gallery = '#EFEFEF';
export const green = '#59BC5F';
export const greenBlue = '#00C983';
export const midGreen = '#1b7d61';
export const grey = '#D4D4D4';
export const lightBlue = '#2CFEF9';
export const midBlue = '#0277a6';
export const lighterGrey = '#F0F0F0';
export const lighterBlue = '#EFF2F7';
export const lighterMidBlue = '#C2CDDD';
export const lightGray = '#EEEEEE';
export const lightGrey = '#F6F6F6';
export const lightMildGray = '#E5E5E5';
export const lightPaleGrey = '#EAEEF1';
export const lightPink = '#eedbdf';
export const lightPurple = '#E6E2F5';
export const lilac = '#F6F5FF';
export const midDarkGray = '#9E9E9E';
export const midGray = '#757575';
export const midHeavyGray = '#9C9C9C';
export const midLighterGray = '#CDCDCD';
export const midLightGray = '#DADADA';
export const midLowGray = '#C9C9C9';
export const mildDarkGray = '#616161';
export const mildGray = '#BAB9B9';
export const navbarActiveColor = '#212529';
export const navbarElementBorderBottom = '#D8D8D8';
export const newYellow = '#F7B500';
export const newYorkPink = '#D58576';
export const offWhite = '#CFCFCF';
export const orange = '#D96D26';
export const paleGrey = '#DBE1E6';
export const paleLavender = '#ECE8F2';
export const pink = '#FC4B88';
export const porsche = '#EFA469';
export const purple = '#461E7D';
export const quartz = '#4A4A4A';
export const reddishPink = '#FF2B6E';
export const someOtherBlue = '#0070EF';
export const stripeEnabled = '#4FD8A4';
export const strongPink = '#FF006E';
export const successGreen = '#47A52A';
export const textDarkGrey = '#333333';
export const textGrey = '#717171';
export const theOtherGrey = '#CECECE';
export const tiffany = '#3DD1A0';
export const tanLight = '#f56b16';
export const transparentColor = '#ffffff00';
export const violetPurple = '#5738FF';
export const warningOrange = '#FEB500';
export const whisper = '#F5F3F8';
export const white = '#FFFFFF';
export const whiteBoxShadow = '#E2E2E2';
export const wildSand = '#F5F5F5';
export const wisteria = '#B6A3CB';
export const yellow = '#FECC32';
export const yellowOrange = '#FBD384';
